export default __webpack_public_path__ + "static/media/filter.22f7b6ee.svg";